import { useCallback, useEffect, useState } from 'react'
import { agentSelfApi, type BankChangeRequestRow } from '../api/agentSelf'
import { Button, Callout, Card, DataTable, EmptyState, LoadingState, Page, PageHeader } from '../components/ui'

/** R3-28: l'Amministrazione approva o rifiuta le richieste di modifica IBAN degli agenti (audit lato server). */
export function AgentBankRequestsPage() {
  const [rows, setRows] = useState<BankChangeRequestRow[] | null>(null)
  const [error, setError] = useState('')
  const [busyId, setBusyId] = useState<number | null>(null)

  const load = useCallback(async () => {
    try {
      setRows(await agentSelfApi.listRequests('pending'))
      setError('')
    } catch (e) {
      setRows([])
      setError(e instanceof Error ? e.message : 'Elenco non disponibile')
    }
  }, [])

  useEffect(() => { void load() }, [load])

  async function decide(id: number, approve: boolean) {
    setBusyId(id)
    setError('')
    try {
      if (approve) await agentSelfApi.approve(id)
      else await agentSelfApi.reject(id)
      await load()
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Decisione non registrata')
    } finally {
      setBusyId(null)
    }
  }

  return (
    <Page>
      <PageHeader title="Modifiche IBAN agenti" icon="account_balance" />
      {error && <Callout tone="error">{error}</Callout>}
      <Card variant="outlined" padding="none">
        {rows === null ? <LoadingState /> : rows.length === 0 ? (
          <EmptyState icon="task_alt" title="Nessuna richiesta in attesa" />
        ) : (
          <DataTable variant="plain" aria-label="Richieste di modifica IBAN in attesa">
            <thead>
              <tr><th>Agente</th><th>Richiesta del</th><th>IBAN attuale</th><th>Nuovo IBAN</th><th className="md-num">Azioni</th></tr>
            </thead>
            <tbody>
              {rows.map(r => (
                <tr key={r.id}>
                  <td>{r.agentCode ?? `#${r.agentProfileId}`}</td>
                  <td>{new Date(r.requestedAt).toLocaleDateString('it-IT')}</td>
                  <td>{r.currentIbanMasked ?? '—'}</td>
                  <td>{r.newIbanMasked ?? '—'}</td>
                  <td className="md-num">
                    <Button type="button" variant="tonal" size="sm" disabled={busyId === r.id} onClick={() => void decide(r.id, true)}>Approva</Button>
                    {' '}
                    <Button type="button" variant="outlined" size="sm" disabled={busyId === r.id} onClick={() => void decide(r.id, false)}>Rifiuta</Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </DataTable>
        )}
      </Card>
    </Page>
  )
}
